<template>
  <orders-datatable />
</template>

<script>
import { warning_message, error_message, get } from "@/utils";
import OrdersDatatable from "./orders_datatable/Index.vue";

export default {
  name: "WoocommerceOrder",
  components: { OrdersDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
